import { render, staticRenderFns } from "./NineView.vue?vue&type=template&id=0adb04b8"
import script from "./NineView.vue?vue&type=script&lang=js"
export * from "./NineView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports